import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import logo from "../../geuzenetlog.png";

import { selectInvoicingSteps } from "../../store/selectors/navigation";
import { selectNewInvoices } from "../../store/selectors/invoicing";
import { getAppUser, setInvoicingSteps } from "../../store/actions/navigation";
import { MemoPanelComponent } from "../../components/invPreselPanel";
import {
  AssetsTextInput2,
  AssetsDatePicker2,
  AssetsCheckbox2,
} from "../../components/assetsInputs";

function NewInvoicesPreselect() {
  const compareArrays = (a, b) => {
    return b.every((value) => a.includes(value));
  };
  const invoicingSteps = useSelector(selectInvoicingSteps);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAppUser());
  }, [dispatch]);

  const newInvoices = useSelector(selectNewInvoices);

  let selectedMoney = 0;
  let allMoney = 0;
  let selectedMoneyInvoicesLines = [];
  for (let selectedMoneyInvoice of newInvoices.filter((invoice) =>
    invoicingSteps.includedInvoicesIds.includes(invoice.id)
  )) {
    selectedMoneyInvoicesLines = [
      ...selectedMoneyInvoicesLines,
      ...selectedMoneyInvoice.invoiceLines.map((line) =>
        parseFloat(
          line.item_quantity && line.item_price
            ? parseFloat(
                Math.round(line.item_quantity * line.item_price * 100) / 100
              ).toFixed(2)
            : 0
        )
      ),
    ];
  }
  for (let selectedMoneyInvoicesLine of selectedMoneyInvoicesLines) {
    selectedMoney = selectedMoney + selectedMoneyInvoicesLine;
  }
  let allMoneyInvoicesLines = [];
  for (let allMoneyInvoice of newInvoices) {
    allMoneyInvoicesLines = [
      ...allMoneyInvoicesLines,
      ...allMoneyInvoice.invoiceLines.map((line) =>
        parseFloat(
          line.item_quantity && line.item_price
            ? parseFloat(
                Math.round(line.item_quantity * line.item_price * 100) / 100
              ).toFixed(2)
            : 0
        )
      ),
    ];
  }
  for (let allMoneyInvoicesLine of allMoneyInvoicesLines) {
    allMoney = allMoney + allMoneyInvoicesLine;
  }
  return (
    <div className="invoicingBody">
      <div>
        {!invoicingSteps.generatingInvoices ? (
          newInvoices.length > 0 ? (
            <div>
              <div className="invNavMain invNavMain2">
                <div className="newInvoicesStepsSub">
                  <AssetsTextInput2
                    descClass={""}
                    desc={"Search:"}
                    // disabled={step !== 3 && newInvoices.length > 0}
                    onChangeFunc={(value) => {
                      dispatch(
                        setInvoicingSteps({
                          ...invoicingSteps,
                          preSelSearch: value,
                          preSelSearchResults: newInvoices
                            .filter(
                              (invoice) =>
                                `${invoice.customer}`
                                  .toLocaleLowerCase()
                                  .includes(value.toLocaleLowerCase()) ||
                                `${invoice.twinfield_id}`
                                  .toLocaleLowerCase()
                                  .includes(value.toLocaleLowerCase()) ||
                                `${invoice.service_id} - ${invoice.user}`
                                  .toLocaleLowerCase()
                                  .includes(value.toLocaleLowerCase()) ||
                                `${
                                  invoice.description
                                    .split("\n")
                                    .reverse()[0]
                                    .split(" ")[2]
                                } - ${
                                  invoice.description
                                    .split("\n")
                                    .reverse()[0]
                                    .split(" ")[4]
                                }`
                                  .toLocaleLowerCase()
                                  .includes(value.toLocaleLowerCase()) ||
                                `${invoice.contract_id}`
                                  .toLocaleLowerCase()
                                  .includes(value.toLocaleLowerCase())
                            )
                            .sort((a, b) => a.contract_id - b.contract_id)
                            .map((invoice) => invoice.id),
                        })
                      );
                    }}
                  />
                  <span className={"includeCounter"}>
                    {parseFloat(Math.round(selectedMoney * 100) / 100).toFixed(
                      2
                    )}
                    €/{parseFloat(Math.round(allMoney * 100) / 100).toFixed(2)}€
                  </span>
                  <span className={"includeCounter"}>
                    {invoicingSteps.includedInvoicesIds.length}/
                    {invoicingSteps.allInvoicesIds.length}
                  </span>
                </div>
                <AssetsCheckbox2
                  className={""}
                  desc={""}
                  value={
                    compareArrays(
                      invoicingSteps.includedInvoicesIds,
                      invoicingSteps.preSelSearchResults
                    ) && invoicingSteps.includedInvoicesIds.length > 0
                  }
                  onChangeFunc={() => {
                    if (
                      compareArrays(
                        invoicingSteps.includedInvoicesIds,
                        invoicingSteps.preSelSearchResults
                      ) &&
                      invoicingSteps.includedInvoicesIds.length > 0
                    ) {
                      let arr = [];
                      for (let invoiceId of invoicingSteps.includedInvoicesIds) {
                        if (
                          !invoicingSteps.preSelSearchResults.includes(
                            invoiceId
                          )
                        ) {
                          arr.push(invoiceId);
                        }
                      }
                      dispatch(
                        setInvoicingSteps({
                          ...invoicingSteps,
                          includedInvoicesIds: arr,
                        })
                      );
                    } else {
                      dispatch(
                        setInvoicingSteps({
                          ...invoicingSteps,
                          includedInvoicesIds: [
                            ...new Set([
                              ...invoicingSteps.includedInvoicesIds,
                              ...invoicingSteps.preSelSearchResults,
                            ]),
                          ],
                        })
                      );
                    }
                  }}
                />
              </div>
              {newInvoices
                .filter(
                  (invoice) =>
                    `${invoice.customer}`
                      .toLocaleLowerCase()
                      .includes(
                        invoicingSteps.preSelSearch.toLocaleLowerCase()
                      ) ||
                    `${invoice.twinfield_id}`
                      .toLocaleLowerCase()
                      .includes(
                        invoicingSteps.preSelSearch.toLocaleLowerCase()
                      ) ||
                    `${invoice.service_id} - ${invoice.user}`
                      .toLocaleLowerCase()
                      .includes(
                        invoicingSteps.preSelSearch.toLocaleLowerCase()
                      ) ||
                    `${
                      invoice.description.split("\n").reverse()[0].split(" ")[2]
                    } - ${
                      invoice.description.split("\n").reverse()[0].split(" ")[4]
                    }`
                      .toLocaleLowerCase()
                      .includes(
                        invoicingSteps.preSelSearch.toLocaleLowerCase()
                      ) ||
                    `${invoice.contract_id}`
                      .toLocaleLowerCase()
                      .includes(invoicingSteps.preSelSearch.toLocaleLowerCase())
                )
                .sort((a, b) => a.contract_id - b.contract_id)
                .map((invoice) => (
                  <MemoPanelComponent invoicePreSel={invoice} />
                ))}
            </div>
          ) : (
            <div>
              <MemoPanelComponent />
            </div>
          )
        ) : (
          <img className="landingLogo ll" src={logo} alt="company logo" />
        )}
      </div>
    </div>
  );
}

export default NewInvoicesPreselect;
